import { type ReactNode, useEffect } from 'react';
import { applyBranding, applyBrandingFonts, type BrandingPalette } from '@gftg/ui';
import { useEvent } from '../lib/queries';

/**
 * The column every screen sits in. Branding is applied here rather than per page, because the
 * palette arrives from the database (CNT-04): the theme's own values render first and the
 * organizer's overrides land as soon as the event query resolves, once for the whole app.
 *
 * What frames a screen — the logo header and footer on home, the tab bar everywhere else — is
 * decided by the layout routes, not here.
 */
export function AppShell({ children }: { children: ReactNode }) {
  const event = useEvent();
  const branding = event.data?.branding;

  useEffect(() => {
    if (!branding) {
      return;
    }
    applyBranding(branding.palette as BrandingPalette);
    applyBrandingFonts({ display: branding.displayFont, ui: branding.uiFont });
  }, [branding]);

  return (
    <div className="mx-auto flex min-h-dvh max-w-screen-sm flex-col bg-canvas">{children}</div>
  );
}
